import Vue from 'vue';

Vue.component('upload-data-table', require('./components/upload-data/Index').default);
Vue.component('ApplicationUploadEditModal', require('./components/upload-data/EditModal').default);
Vue.component('ApplicationUploadAddModal', require('./components/upload-data/ApplicationAddModal').default);
Vue.component('ApplicationUploadForm', require('./components/upload-data/form/Index').default);
Vue.component('scopes-upload-index', require('./components/upload-data/form/scopes/Index').default);
Vue.component('scopes-upload-table', require('./components/upload-data/form/scopes/Table').default);
Vue.component('scopes-upload-modal', require('./components/upload-data/form/scopes/Modal').default);
Vue.component('annexed-upload-modal', require('./components/upload-data/form/annexed/Index').default);

Vue.component('pending-process-index', require('./components/upload-data/form/pending-process/Index').default);
Vue.component('pending-process-modal', require('./components/upload-data/form/pending-process/Modal').default);
Vue.component('pending-process-table', require('./components/upload-data/form/pending-process/Table').default);

Vue.component('ApplicationTable', require('./components/application/Index').default);
Vue.component('ApplicationAddModal', require('./components/application/ApplicationAddModal').default);
Vue.component('document-modal', require('./components/application/DocumentModal').default);

Vue.component('ApplicationForm', require('./components/application/form/Index').default);
Vue.component('FormGeneral', require('./components/application/form/General').default);

Vue.component('FormOrganization', require('./components/application/form/organization/Index').default);
Vue.component('OrganizationParent', require('./components/application/form/organization/Parent').default);
Vue.component('OrganizationBranch', require('./components/application/form/organization/Branch').default);
Vue.component('EvaluationData', require('./components/application/form/organization/EvaluationData').default);

// Vue.component('FormRequest', require('./components/application/form/accreditation-scopes/Index').default);
// Vue.component('FormRequestModal', require('./components/application/form/accreditation-scopes/Modal').default);
// Vue.component('FormRequestTree', require('./components/application/form/accreditation-scopes/Tree').default);

Vue.component('FormDetail', require('./components/application/form/detail/Index').default);
Vue.component('FormResponsable', require('./components/application/form/detail/Responsable').default);
Vue.component('FormResponsableAdd', require('./components/application/form/detail/ResponsableAdd').default);

Vue.component('responsable-table', require('./components/application/form/detail/Responsable/Index').default);
Vue.component('responsable-modal', require('./components/application/form/detail/Responsable/Modal').default);

Vue.component('LaboratoryStaffTable', require('./components/application/form/detail/LaboratoryStaffTable').default);
Vue.component('LaboratoryStaffModal', require('./components/application/form/detail/LaboratoryStaffModal').default);

Vue.component('FormAnnexes', require('./components/application/form/annexed/Index').default);
Vue.component('AnnexedList', require('./components/application/form/annexed/AnnexedList').default);
Vue.component('TestEquipment', require('./components/application/form/annexed/TestEquipment').default);
Vue.component('TestEquipmentModal', require('./components/application/form/annexed/TestEquipmentModal').default);
Vue.component('ProfTestInter', require('./components/application/form/annexed/ProfTestInter').default);
Vue.component('ProfTestInterModal', require('./components/application/form/annexed/ProfTestInterModal').default);
Vue.component('Local', require('./components/application/form/annexed/Local').default);

Vue.component('FormCommitment', require('./components/application/form/ComplianceCommitment').default);
Vue.component('FormSendRequest', require('./components/application/form/SendRequest').default);

Vue.component('branchs-table', require('./components/application/form/organization/branchs/Index').default);
Vue.component('branchs-modal', require('./components/application/form/organization/branchs/Modal').default);

Vue.component('branchs-critical-table', require('./components/application/form/organization/branchs-critical/Index').default);
Vue.component('branchs-critical-modal', require('./components/application/form/organization/branchs-critical/Modal').default);

Vue.component('acc-bodies-table', require('./components/application/form/organization/acc-bodies/Index').default);
Vue.component('acc-bodies-modal', require('./components/application/form/organization/acc-bodies/Modal').default);

Vue.component('other-locations-table', require('./components/application/form/organization/other-locations/Index').default);
Vue.component('other-locations-modal', require('./components/application/form/organization/other-locations/Modal').default);

Vue.component('acc-virtual-sites-table', require('./components/application/form/organization/acc-virtual-sites/Index').default);
Vue.component('acc-virtual-sites-modal', require('./components/application/form/organization/acc-virtual-sites/Modal').default);

Vue.component('certification-activities-table', require('./components/application/form/organization/certification-activities/Index').default);
Vue.component('certification-activities-modal', require('./components/application/form/organization/certification-activities/Modal').default);

Vue.component('rehearsal-activities-table', require('./components/application/form/annexed/rehearsal-activities/Index').default);
Vue.component('rehearsal-activities-modal', require('./components/application/form/annexed/rehearsal-activities/Modal').default);

Vue.component('subcontractors-table', require('./components/application/form/annexed/subcontractors/Index').default);
Vue.component('subcontractors-modal', require('./components/application/form/annexed/subcontractors/Modal').default);

Vue.component('scopes-index', require('./components/application/form/scopes/Index').default);
Vue.component('scopes-table', require('./components/application/form/scopes/Table').default);
Vue.component('scopes-modal', require('./components/application/form/scopes/Modal').default);

Vue.component('scope-sampling-table', require('./components/application/form/scopes/sampling/Index').default);
Vue.component('scope-sampling-modal', require('./components/application/form/scopes/sampling/Modal').default);



/* Payment */
Vue.component('payment-index', require('./components/application/payment/Index').default);
Vue.component('payment-edit', require('./components/application/payment/Tabs/Index').default);

Vue.component('payment-aprove', require('./components/application/payment-aprove/Index').default);

//administrar Licencias
Vue.component('license-management-index', require('./components/application/manage-license/Index').default);
Vue.component('license-management-oec', require('./components/application/manage-license/IndexOec').default);

//licenses 
Vue.component('renew-payment-index', require('./components/application/renew-payment/license-renewal/Index').default);
Vue.component('renew-payment-retab', require('./components/application/renew-payment/license-renewal/Tab').default);
Vue.component('renew-payment-tab', require('./components/application/renew-payment/Tabs/Index').default);
Vue.component('renew-payment-modal', require('./components/application/renew-payment/license-renewal/ModalRenewal').default);

//Oficio suspencion y reduccion
Vue.component('voluntary-officio-index', require('./components/application/voluntary-officio/Index').default);
Vue.component('voluntary-officio-modal', require('./components/application/voluntary-officio/ModalOffic').default);
Vue.component('voluntary-officio-tabcont', require('./components/application/voluntary-officio/scopes/TabContent').default);
Vue.component('officio-scopes-modal', require('./components/application/voluntary-officio/scopes/Modal').default);
Vue.component('officio-sampling-modal', require('./components/application/voluntary-officio/scopes/Sampling/Modal').default);
Vue.component('officio-sampling-table', require('./components/application/voluntary-officio/scopes/Sampling/Table').default);
